import React from 'react'
import JobBox from './JobBox'
import NoRecords from '../../components/noRecords/NoRecords'

const JobContainer = ({ list, type, handleTip, cancelRequest, updateJobRequest, handleMarkComplete, handleDispute, handleReview, handlePayment, handleInvoice }) => {
  return (
    <>
    {
      list?.length > 0 ?
      <div className={`w-100 ${type}`} >
        <div className='job-tab-content '>
          {
            list?.map((job, index) => {
              return (
                <JobBox
                  key={index}
                  type={type}
                  job={job}
                  updateJobRequest={updateJobRequest}
                  handleMarkComplete={handleMarkComplete}
                  handleDispute={handleDispute}
                  handleReview={handleReview}
                  cancelRequest={cancelRequest}
                  handleTip={handleTip}
                  handlePayment={handlePayment}
                  handleInvoice={handleInvoice}

                 />
              )
            })
          }
        </div>
      </div>
      :
      <NoRecords />
    }
    </>

  )
}

export default JobContainer
